import styled from 'styled-components';
import { MIN_TABLET_BREAKPOINT, SELECTORS } from '../../constants/constants';


export const BadgesHeader = styled.h2`
    ${SELECTORS} & {
      text-align: center;
      font-weight: bold;
      font-size: 50px;
      line-height: 50px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
        ${SELECTORS} & {
            font-size: 32px;
            line-height: 38px;
        }
    }
`;

export const BadgesDescription = styled.p`
    ${SELECTORS} & {
      text-align: center;
      width: 70%;
      margin: 45px auto 60px auto;
      font-size: 25px;
      font-weight: 400;
      line-height: 24px;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) { 
          ${SELECTORS} & {
             text-align: left;
             width: 100%;
             font-size: 20px;
             margin-top: 20px;
             margin-bottom: 40px;
          }
    }
`;


